<template>
  <div class="area-manage tree-line-style section-main__warp">
    <!-- area-tree -->
    <div class="area-tree-left">
      <div class="area-title">已有区域信息</div>
      <div class="area-search">
        <el-input placeholder="请输入搜索关键字" prefix-icon="el-icon-search" v-model="searchString" clearable>
        </el-input>
      </div>
      <el-scrollbar class="scroll-bar">
        <el-tree ref="tree" class="tree-content" :data="tableData" :expand-on-click-node="false" node-key="id"
          :default-expanded-keys="expandedKeys" render-after-expand :load="asyncLoadNode" :lazy="lazyLoad"
          :props="treeProps" :highlight-current="true" :filter-node-method="filterNode" @node-click="nodeClick">
          <template slot-scope="{ node, data }">
            <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
              <span class="custom-tree-node">
                <span class="tree-label" :title="node.label"> {{ node.label }}</span>
                <span v-if="areaDetailsInfo.id === data.id">
                  <div class="area-operator" @click="addClick">
                    <el-button type="text" class="el-icon-plus" v-auth="'/area:add'" size="medium"
                      @click="() => appendArea(data)"></el-button>

                    <el-button type="text" v-auth="'/area:update'" class="el-icon-edit-outline" size="medium"
                      @click="() => editArea(node, data)"></el-button>
                    <el-button v-if="areaDetailsInfo.id !== parkId" type="text" class="el-icon-delete-solid"
                      v-auth="'/area:delete'" size="medium" @click="() => removeArea(node, data)"></el-button>
                  </div>
                </span>
              </span>
            </element-tree-line>
          </template>
        </el-tree>
      </el-scrollbar>
    </div>
    <div class="area-tree-right">
      <div class="details">
        <!-- <h3 style="margin-bottom: 30px">
          区域配置说明--{{ showType == "edit" ? "编辑" : "详情" }}
        </h3> -->
        <ioc-forms ref="areaForm" v-model="areaDetailsInfo" :option="areaOptions">
          <template slot-scope="scope" slot="ownerList">
            <div class="owner-list">
              <el-input placeholder="无" :disabled="!showType" :readonly="showType ? true : false"
                v-model="areaDetailsInfo.ownerList">{{ scope }}</el-input>
              <img style="cursor: pointer; position: absolute; top: 10px; right: 10px"
                src="@src/common/assets/images/icon/more.png" @click="queryPersonType(1)" v-if="showType" alt="" />
              <!-- <el-button
                type="text"
                v-if="showType"
                class="choose-person el-icon-user-solid"
                @click="queryPersonType(1)"
                >点击选择人员</el-button
              > -->
            </div>
          </template>
          <template slot-scope="scope" slot="keeperList">
            <div class="owner-list">
              <el-input placeholder="无" :disabled="!showType" :readonly="showType ? true : false"
                v-model="areaDetailsInfo.keeperList">{{ scope }}</el-input>
              <img style="cursor: pointer; position: absolute; top: 10px; right: 10px"
                src="@src/common/assets/images/icon/more.png" @click="queryPersonType(2)" v-if="showType" alt="" />
              <!-- <el-button
                type="text"
                v-if="showType"
                class="choose-person el-icon-user-solid"
                @click="queryPersonType(2)"
                >点击选择人员</el-button
              > -->
            </div>
          </template>
          <template slot="color">
            <el-color-picker v-model="areaDetailsInfo.color"></el-color-picker>
            <span style="color: gray; position: absolute; top: 5px"> 默认是黄色</span>
          </template>
          <template slot-scope="scope" slot="drawName">
            <div class="owner-list">
              <el-input :disabled="!showType" :readonly="showType ? true : false" placeholder="请点击右侧地图查看区域"
                v-model="areaDetailsInfo.drawName">{{ scope }}</el-input>
              <el-button type="text" size="small" style="position: absolute; right: 0px; font-size: 18px; top: -3px"
                class="iconfont icon-position choose-person" @click="handleOpenPanel"></el-button>
            </div>
          </template>
        </ioc-forms>
      </div>
      <div class="btns" v-if="showType">
        <el-button type="info" @click="resetArea"> 重置</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveArea">{{
          btnLoading ? "保存中" : "保 存"
        }}</el-button>
      </div>
    </div>
    <el-dialog title="人员列表" v-dialogDrag :visible.sync="showPerson" :before-close="closePerson" @close="closePerson"
      class="choose-container" width="63%">
      <ioc-table :data="tableList" :option="tableOption" :page="page" ref="iocTable" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        @refresh-change="refreshChange" @selection-change="handleSelectionChange"></ioc-table>
      <div slot="footer" class="dialog-footer tc" style="text-align: right">
        <el-button @click="closePerson" type="info">{{
          $t("area.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitPerson">{{
          $t("area.button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <app-panel isScreen :isExpand="showMap" @screen="handleScreen" @cancel="handleClosePanel"
      :title="showType ? '区域配置' : '查看区域配置'">
      <div class="colorArea">
        <div class="tipLabel" v-if="showType">
          绘制提示: 请使用鼠标左击开始绘制，右键双击结束绘制
        </div>
        <div class="old" v-if="checkAreaList">
          <span>绘制区域</span>
          <div :style="{
            background: areaDetailsInfo.color,
          }"></div>
        </div>
      </div>
      <div id="mini-map" ref="miniMap">
        <appMap ref="refAppMap" divId="miniMap"></appMap>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel">{{
          $t("taskCenter.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="mapConfirmOpt" v-if="showType != ''">{{
          $t("taskCenter.button.conform")
        }}</el-button>
      </span>
    </app-panel>
  </div>
</template>
<script>
import Vue from "vue";
import appMap from "@src/components/common/gis/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import ElementTreeLine from "element-tree-line";
import utils from "$utils";
import { api } from "./api";
export default {
  components: {
    ElementTreeLine,
    appPanel,
    appMap,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    let checkLng = (rule, value, callback) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !/^[-+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,10}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,10}|180|180\.0{1,10})$/.test(
          value
        )
      ) {
        callback(new Error(this.$t("area.message.lng")));
      } else {
        callback();
      }
    };
    let checkName = (rule, value, callback) => {
      if (/^\s+|\s+$/g.test(value) && value !== "") {
        callback(new Error(this.$t("area.message.nospace")));
      } else {
        callback();
      }
    };
    let checkLat = (rule, value, callback) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !/^[-+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,10}|90|90\.0{1,10})$/.test(value)
      ) {
        callback(new Error(this.$t("area.message.lat")));
      } else {
        callback();
      }
    };
    return {
      checkAreaListCopy: [],
      nodeClickInfo: {},
      isExpand: false,
      color: "#846505", //'#F2E70D',
      fullscreen: false,
      key: 0,
      dicData: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],
      title: "",
      visible: false,
      searchString: "",
      isDisabled: true,
      tableData: Object.freeze([]),
      areaNames: [],
      showType: "",
      parkId: "",
      diaWidth: "60%",
      areaInfo: {
        index: "",
        id: "",
        father: "",
        lng: "",
        lat: "",
        name: "",
        desc: "",
      },
      // 展开的节点id
      expandedKeys: [],
      treeProps: {
        children: "children",
        label: "name",
        id: "id",
        isLeaf: "isLeaf",
      },
      lazyLoad: false,
      // 缓存全量树结构
      cacheTree: [],
      areaDetailsInfo: {
        isWorkShop: "0",
      },
      checkAreaList: null, //选中的区域配置
      areaOptions: {
        menuBtn: false,
        labelWidth: 100,
        labelPosition: "right",
        column: [
          // {
          //   label: "区域编码",
          //   prop: "id",
          //   span: 12,
          //   disabled: true,
          // },
          {
            label: "上级区域",
            prop: "parentName",
            span: 24,
            disabled: true,
          },
          {
            label: "区域名称",
            placeholder: this.$t("area.placeholder.name"),
            prop: "name",
            span: 24,
            rules: [
              {
                required: true,
                message: this.$t("area.message.name"),
                trigger: "blur",
              },
              // {
              //   min: 1,
              //   max: 30,
              //   message: this.$t("area.message.less30"),
              //   trigger: "blur",
              // },
            ],
            disabled: true,
          },
          {
            label: this.$t("area.label.ownerList"),
            placeholder: this.$t("area.placeholder.ownerList"),
            prop: "ownerList",
            clearable: false,
            span: 24,
            formslot: true,
            rules: [
              {
                required: false,
                message: this.$t("area.message.ownerList"),
                trigger: "blur",
              },
            ],
            disabled: true,
          },
          {
            label: "通行管理员",
            placeholder: "请选择通行管理员",
            prop: "keeperList",
            clearable: false,
            span: 24,
            formslot: true,
            rules: [
              {
                required: false,
                message: this.$t("area.message.ownerList"),
                trigger: "blur",
              },
            ],
            disabled: true,
          },
          {
            label: "绘制区域",
            placeholder: "请点击右侧地图绘制区域",
            prop: "drawName",
            span: 24,
            clearable: true,
            formslot: true,
            // rules: [
            //   { required: true, message: "请点击右侧地图绘制区域", trigger: 'change' },
            // ],
            disabled: true,
            display: true, //是否显示
          },
          {
            label: "查看区域",
            placeholder: "请点击右侧地图查看区域",
            prop: "drawName",
            span: 24,
            formslot: true,
            disabled: true,
            display: false, //是否显示
          },
          {
            label: "区域颜色",
            prop: "color",
            formslot: true,
            span: 24,
            display: true, //是否显示
          },
          // {
          //   label: this.$t('area.label.longitude'),
          //   placeholder: this.$t('area.placeholder.longitude'),
          //   prop: 'lng',
          //   span: 12,
          //   rules: [
          //     { required: true, message: this.$t('area.placeholder.longitude'), trigger: 'blur' },
          //     { min: 1, max: 15, message: this.$t('area.message.less15'), trigger: 'blur' },
          //     { validator: checkLng, message: this.$t('area.message.lng'), trigger: 'blur' },
          //   ],
          //   disabled: false,
          // },
          // {
          //   // label: '',
          //   label: this.$t('area.label.latitude'),
          //   prop: 'lat',
          //   placeholder: this.$t('area.placeholder.latitude'),
          //   labelWidth: 1,
          //   span: 12,
          //   rules: [
          //     { required: true, message: this.$t('area.placeholder.latitude'), trigger: 'blur' },
          //     { min: 1, max: 15, message: this.$t('area.message.less15'), trigger: 'blur' },
          //     { validator: checkLat, message: this.$t('area.message.lat'), trigger: 'blur' },
          //   ],
          //   disabled: false,
          // },
          // {
          //   label: this.$t('area.label.workshopArea'),
          //   prop: 'isWorkShop',
          //   placeholder: '请选择',
          //   span: 24,
          //   type: 'select',
          //   disabled: false,
          //   formslot: true,
          // },
          {
            label: "区域说明",
            prop: "desc",
            placeholder: this.$t("area.placeholder.remark"),
            span: 24,
            maxlength: 200,
            rules: [
              {
                min: 0,
                max: 200,
                message: this.$t("area.message.less200"),
                trigger: "blur",
              },
            ],
            type: "textarea",
            disabled: true,
          },
        ],
      },
      showPerson: false,
      showMap: false,
      tableList: [],
      personList: [],
      tableOption: {
        selection: true,
        index: true,
        column: [
          {
            label: this.$t("area.label.workNo"),
            prop: "workNo",
            search: true,
            clearable: true,
          },
          {
            label: this.$t("area.label.personnelName"),
            // search: true,
            prop: "name",
            search: true,
            clearable: true,
          },
          {
            label: this.$t("area.label.sex"),
            prop: "sex",
            formatter: (row, value) => {
              if (Number(value) === 1) {
                return "男";
              } else if (value === null) {
                return "";
              } else if (Number(value) === 0) {
                return "女";
              }
            },
          },
          {
            label: this.$t("area.label.phone"),
            search: true,
            clearable: true,
            prop: "phone",
          },
          {
            label: this.$t("area.label.departmentName"),
            prop: "departmentName",
          },
          {
            label: this.$t("area.label.position"),
            prop: "positionName",
            search: true,
            clearable: true,
          },
        ],
      },
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      isTopTreeNode: true,
      searchParams: {},
      btnLoading: false,
      addPolygonId: "polyGonID",
      addPolygonEditId: "polyGonEditID",
    };
  },

  created() {
    const account = utils.Cache.get("CACHE_USER_INFO");
    if (account && account.parkInfo) {
      this.parkId = account.parkInfo.areaDevGroupCode;
    }
    this.getAreaInfo();
  },
  beforeDestroy() {
    this.$refs.refAppMap.destroyLocation();
  },
  mounted() { },
  methods: {
    handleScreen() {
      this.$refs.refAppMap.refreshMap();
    },
    appendArea(data) {
      this.nodeClickInfo = JSON.parse(JSON.stringify(data));
      this.showType = "add";
      this.areaDetailsInfo.parentName = data.name;
      this.areaDetailsInfo.name = "";
      this.areaDetailsInfo.ownerList = "";
      this.areaDetailsInfo.keeperList = "";
      this.areaDetailsInfo.drawName = "";
      this.areaDetailsInfo.personList = [];
      this.areaDetailsInfo.personListKeeper = [];
      this.areaDetailsInfo.color = this.areaDetailsInfo.color;
      this.checkAreaList = [];
      this.areaDetailsInfo.desc = "";
      this.areaDetailsInfo.isWorkShop = "0";
      this.areaOptions.column[1].disabled = false; //区域名称
      this.areaOptions.column[4].display = true;
      this.areaOptions.column[5].display = false;
      this.areaOptions.column[6].display = true;
      this.areaOptions.column[7].disabled = false;
      // this.areaOptions.column[0].display = false;
      this.areaOptions.column[0].span = 24;
      this.areaOptions.column[0].display = true;
    },
    resetArea() {
      this.$refs.areaForm.$refs.form.resetFields();
      this.showType == "edit"
        ? this.editArea({}, this.nodeClickInfo)
        : this.appendArea(this.nodeClickInfo);
    },
    addClick(event) {
      event.stopPropagation();
    },
    removeArea() {
      this.deleteArea();
    },
    editArea(node, data) {
      this.nodeClick(data);
      this.nodeClickInfo = JSON.parse(JSON.stringify(data));
      this.showType = "edit";
      this.areaOptions.column[1].disabled = false; //区域名称
      this.areaOptions.column[7].disabled = false; //区域说明
    },
    saveArea() {
      this.$refs["areaForm"].$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.showType === "add") {
          this.addInfo();
        } else {
          this.fixInfo();
        }
      });
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 异步加载树子节点
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    // 添加虚拟节点
    append(node, res) {
      const newChild = {
        id: res.areaDevGroupCode,
        name: res.areaDevGroupName,
        desc: res.desc,
        areaColor: res.areaColor,
        areaPointList: res.areaPointList,
        // lat: res.lat,
        // lng: res.lng,
        isWorkShop: res.isWorkShop,
        personList: [].concat(res.ownerList),
        personListKeeper: [].concat(res.keeperList),
        ownerList: this.showOwnerList(res.ownerList),
        keeperList: this.showOwnerList(res.keeperList),
        parentCode: res.parentCode,
        isLeaf: false,
      };
      if (!node.children) {
        this.$set(node, "children", []);
      }
      node.children.push(newChild);
    },
    // 更新虚拟节点
    update(data, res) {
      // console.log(res);
      const newChild = {
        id: res.areaDevGroupCode,
        name: res.areaDevGroupName,
        desc: res.desc,
        areaColor: res.areaColor,
        areaPointList: res.areaPointList,
        isWorkShop: res.isWorkShop,
        personList: [].concat(res.ownerList),
        personListKeeper: [].concat(res.keeperList),
        ownerList: this.showOwnerList(res.ownerList),
        keeperList: this.showOwnerList(res.keeperList),
        parentCode: res.parentNode,
        children: data.children,
      };
      Object.keys(newChild).map((item) => {
        if (newChild[item]) {
          this.$set(data, item, newChild[item]);
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.areaDevGroupCode;
          entity.name = item.areaDevGroupName;
          entity.lng = item.lng;
          entity.lat = item.lat;
          entity.desc = item.desc;
          entity.areaPointList = item.areaPointList;
          entity.areaColor = item.areaColor;
          entity.isWorkShop = item.isWorkShop;
          entity.parentCode = item.parentCode;
          entity.personList = [].concat(item.ownerList);
          entity.personListKeeper = [].concat(item.personListKeeper || []);
          entity.ownerList = self.showOwnerList(item.ownerList || []);
          entity.keeperList = self.showOwnerList(item.keeperList || []);
          entity.isLeaf = !item.hasLeaf || !item.childrens;
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens);
          }
          result.push(entity);
        });
        return result;
      }
    },
    showOwnerList(list) {
      // console.log(list);
      return list.map((item) => item.personnelName).join(",");
    },
    //获取区域列表
    getAreaInfo() {
      const self = this;
      const account = utils.Cache.get("CACHE_USER_INFO");
      this.$fetch(api.area.list, {
        accountNumber: account.account,
      }).then((response) => {
        let parentNode = account.parkInfo;
        const result = self.menusDataPro(response.returnObj);
        self.cacheTree = result;
        self.tableData = Object.freeze(result);
        self.nodeClick(self.tableData[0]);
        self.$nextTick(() => {
          self.$refs.tree.setCurrentKey(self.tableData[0]);
        });
        self.expandedKeys = [parentNode.areaDevGroupCode];
      });
    },
    //添加区域
    addInfo() {
      // console.log(this.checkAreaList);
      let list = this.checkAreaList.map((item) => {
        return {
          lng: item[0].toFixed(10),
          lat: item[1].toFixed(10),
        };
      });
      // for (var i = 0; i < this.checkAreaList.length; i = i + 2) {
      //   list.push({
      //     lng: this.checkAreaList[i].toFixed(10),
      //     lat: this.checkAreaList[i + 1].toFixed(10),
      //   });
      // }

      let area = {
        type: 2,
        areaColor: this.areaDetailsInfo.color,
        areaPointList: list,
        parentCode: this.areaDetailsInfo.id,
        areaDevGroupName: this.areaDetailsInfo.name,
        ownerList: this.areaDetailsInfo.personList,
        keeperList: this.areaDetailsInfo.personListKeeper,
        desc: this.areaDetailsInfo.desc,
        isWorkShop: this.areaDetailsInfo.isWorkShop,
      };
      this.btnLoading = true;
      this.$fetch(api.area.addArea, area).then((response) => {
        setTimeout(() => {
          this.btnLoading = false;
        }, 500);
        if (response.success) {
          this.$message({
            type: "success",
            message: this.$t("area.message.addSuccess"),
          });
          this.visible = false;
          this.showType = "";
          let currentNode = this.$refs.tree.getCurrentNode();
          this.nodeClick(currentNode);
          this.expandedKeys = [currentNode.id];
          this.append(currentNode, response.returnObj);
        } else {
          this.$message({
            type: "error",
            message: response.msgContent,
          });
        }
      });
    },
    //修改区域
    fixInfo() {
      let currentNode = this.$refs.tree.getCurrentNode();
      let list = [];
      for (var i = 0; i < this.checkAreaList.length; i++) {
        list.push({
          lng: this.checkAreaList[i][0].toFixed(10),
          lat: this.checkAreaList[i][1].toFixed(10),
        });
      }
      let area = {
        type: 2,
        areaDevGroupCode: this.areaDetailsInfo.id,
        areaColor: this.areaDetailsInfo.color,
        areaPointList: list,
        areaDevGroupName: this.areaDetailsInfo.name,
        ownerList: this.areaDetailsInfo.personList,
        keeperList: this.areaDetailsInfo.personListKeeper,
        desc: this.areaDetailsInfo.desc,
        isWorkShop: this.areaDetailsInfo.isWorkShop,
      };
      this.btnLoading = true;
      this.$fetch(api.area.fixArea, area).then((response) => {
        setTimeout(() => {
          this.btnLoading = false;
        }, 500);
        if (response.success) {
          this.update(currentNode, area);
          this.$message({
            type: "success",
            message: this.$t("area.message.editSuccess"),
          });
          this.areaOptions.column[1].disabled = true;
          // this.areaOptions.column[5].disabled = true;
          this.areaOptions.column[7].disabled = true;
          this.visible = false;
          this.showType = "";
        } else {
          this.$message({
            type: "error",
            message: response.msgContent,
          });
        }
      });
    },
    // 单击节点时
    nodeClick(data) {
      // console.log("nodeClick:", data);
      this.showType = "";
      this.handleClosePanel();
      this.isTopTreeNode = data.id !== "-1" ? false : true;
      let parentNode = this.$refs.tree.getNode(data.parentCode);
      this.areaDetailsInfo = {
        id: data.id,
        name: data.name,
        drawName: (data.areaPointList.length && "【已配置，请查看】") || "",
        parentName: "",
        personList: data.personList,
        personListKeeper: data.personListKeeper,
        ownerList: data.ownerList,
        keeperList: data.keeperList,
        desc: data.desc,
        color: data.areaColor || this.color,
        isWorkShop: data.isWorkShop,
      };
      this.checkAreaList = [];
      data.areaPointList.forEach((el) => {
        this.checkAreaList.push([Number(el.lng), Number(el.lat)]);
      });
      if (parentNode && parentNode.data) {
        this.areaDetailsInfo.parentName = parentNode.data.name;
      }
      if (data.id == "200000001") {
        // 根节点
        this.areaOptions.column[0].display = false;
        // this.areaOptions.column[0].span = 24;
        this.areaOptions.column[4].display = false; //绘制区域
        this.areaOptions.column[5].display = true; //查看区域
        this.areaOptions.column[6].display = false; //区域颜色
      } else {
        this.areaOptions.column[0].display = true;
        // this.areaOptions.column[0].span = 12;
        this.areaOptions.column[4].display = true;
        this.areaOptions.column[5].display = false;
        this.areaOptions.column[6].display = true;
      }
      // this.areaOptions.column[5].disabled = true;//绘制区域
      // this.areaOptions.column[6].disabled = true;//查看区域
      this.areaOptions.column[1].disabled = true; //区域名称
      this.areaOptions.column[7].disabled = true; //区域说明

      // console.log(this.areaOptions);
    },
    closeDialog() {
      this.visible = false;
    },
    deleteArea() {
      let info = this.$refs.tree.getCurrentNode();
      // console.log(info);
      if (!info) {
        this.$message.warning(this.$t("area.message.selecttips"));
        return;
      }

      this.$confirm(this.$t("area.message.deltips"), "删除确认", {
        confirmButtonText: this.$t("area.button.confirm"),
        cancelButtonText: this.$t("area.button.cancel"),
        type: "warning",
      })
        .then(() => {
          let ids = {
            areaDevGroupCodesList: [],
          };
          ids.areaDevGroupCodesList.push(info.id);
          this.$fetch(api.area.deleteArea, ids).then((response) => {
            if (response.success) {
              this.$message({
                type: "success",
                message: this.$t("area.message.delSuccess"),
              });
              this.expandedKeys = [info.parentCode];
              this.$refs.areaForm.resetForm();
              this.$refs.tree.remove(info);
              this.$refs.tree.setCurrentKey({ id: info.parentCode });
              this.$nextTick(() => {
                this.nodeClick(this.$refs.tree.getCurrentNode());
              });
              //删除节点时,设置当前选中节点为空,防止在删除节点后继续操作修改或新增时会显示之前删除节点的信息
              // this.$refs.tree.setCurrentNode({ id: '' });
            } else {
              this.$message({
                type: "error",
                message: response.msgContent,
              });
            }
          });
        })
        .catch(() => { });
    },
    handleSearchReset() {
      this.queryPerson();
    },
    refreshChange() {
      this.queryPerson();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryPerson();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.queryPerson();
    },
    handleSearchChange(param) {
      this.page.currentPage = 1;
      this.searchParams = Object.assign(param);
      this.queryPerson();
    },
    handleSelectionChange(items) {
      if (this.choosePeopleType == 2 && items.length > 2) {
        this.$message.warning("通行管理员最多选择2位,请重新选择");
        this.$refs.iocTable.$refs.multipleTable.clearSelection();
        return;
      }
      this.personList = items.map((item) => {
        return {
          personnelCode: item.personnelCode,
          personnelName: item.name,
        };
      });
    },
    queryPersonType(type) {
      this.choosePeopleType = type; //1 区域负责人，2通行管理员
      this.queryPerson();
    },
    queryPerson() {
      this.showPerson = true;
      const params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        personnelType: 1,
        ...this.searchParams,
      };
      this.$fetch(api.area.queryPersonList, params).then((response) => {
        if (response.success) {
          this.tableList = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    submitPerson() {
      this.areaDetailsInfo[
        this.choosePeopleType == 1 ? "ownerList" : "keeperList"
      ] = this.personList.map((r) => r.personnelName).join(",");
      this.areaDetailsInfo[
        this.choosePeopleType == 1 ? "personList" : "personListKeeper"
      ] = [].concat(this.personList);
      this.showPerson = false;
    },
    closePerson() {
      this.showPerson = false;
    },
    handleOpenPanel() {
      this.showMap = true;
      this.initMap();
      // 地图组件手动挂载方式
      // const appPanelMap = Vue.extend(appMap);
      // //挂载播放器实例
      // const MapInstance = new appPanelMap({
      //   propsData: {
      //     divId: "miniMap",
      //   },
      // }).$mount();
      // this.$nextTick(() => {
      //   this.$refs["miniMap"].appendChild(MapInstance.$el);
      // });
    },
    // 递归渲染多个区域
    treeDataArea(data = []) {
      const self = this;
      data.forEach(function (item) {
        if (item.areaPointList.length) {
          self.checkAreaList = [];
          item.areaPointList.forEach((el) => {
            self.checkAreaList.push([Number(el.lng), Number(el.lat)]);
          });
          // TODO 区域取中心点位计算
          let addMarkInfo = [];
          let sumX = 0;
          let sumY = 0;
          let length = 0;
          self.checkAreaList.forEach(function (areaPoint) {
            sumX += areaPoint[0];
            sumY += areaPoint[1];
            length = self.checkAreaList.length; // 获取数组的长度
          });
          if (sumX != 0 & sumY != 0) {
            addMarkInfo.push({  // 区域取中心点位计算
              id: item.id,
              longitude: Number(),
              latitude: Number(),
              coord: [Number(sumX / length), Number(sumY / length)],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/floor/" + item.name + ".png",
              sleSrc: "/images/theme/newDark/floor/" + item.name + ".png",
              attr: {
                ...item,
              },
            });
          }
          //区域名称打点
          self.$refs.refAppMap.addMarket(
            addMarkInfo,
            item.id + '_areaName',
            ''
          );
          self.$refs.refAppMap.addPolygon(
            item.id,
            item.areaColor || "#846505",
            [self.checkAreaList],
            item.name
          );
        }
        if (item.children) {
          self.treeDataArea(item.children);
        }
      });
    },
    initMap() {
      this.$refs.refAppMap.setMapCenter();
      if (this.showType) {
        // 编辑模式 add 和edit
        // 根节点不能编辑和修改
        if (this.areaDetailsInfo.id == "200000001" && this.showType == "edit") {
          // 渲染多个区域
          this.treeDataArea(this.tableData);
          return;
        }
        // 绘制已经绘制过的数据，如果没用清空
        if (this.checkAreaList) {
          this.$refs.refAppMap.addPolygon(
            this.areaDetailsInfo.id || this.addPolygonID,
            this.areaDetailsInfo.color || "#846505",
            [this.checkAreaList],
            this.areaDetailsInfo.name
          );
           // TODO 区域取中心点位计算
           let addMarkInfo = [];
          let sumX = 0;
          let sumY = 0;
          let length = this.checkAreaList.length;
          this.checkAreaList.forEach(function (areaPoint) {
            sumX += areaPoint[0];
            sumY += areaPoint[1];
          });
          if (sumX != 0 & sumY != 0) {
            addMarkInfo.push({  // 区域取中心点位计算
              id: this.areaDetailsInfo.id + '_areaName',
              longitude: Number(),
              latitude: Number(),
              coord: [Number(sumX/length), Number(sumY/length)],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/floor/" + this.areaDetailsInfo.name + ".png",
              sleSrc: "/images/theme/newDark/floor/" + this.areaDetailsInfo.name + ".png",
              attr: {
                ...this.areaDetailsInfo,
              },
            });
          }
          //区域名称打点
          this.$refs.refAppMap.addMarket(
            addMarkInfo,
            this.areaDetailsInfo.id + '_areaName' || this.addPolygonID + '_areaName',
            ''
          );
        }
        this.$refs.refAppMap.drawFeature(this.drawCallback); //开始绘制
      } else {
        //视图模式
        if (this.areaDetailsInfo.id == "200000001") {
          // 渲染多个区域
          this.treeDataArea(this.tableData);
        } else {
          this.$refs.refAppMap.addPolygon(
            this.areaDetailsInfo.id || this.addPolygonID,
            this.areaDetailsInfo.color || "#846505",
            [this.checkAreaList],
            this.areaDetailsInfo.name
          );
          // TODO 区域取中心点位计算
          let addMarkInfo = [];
          let sumX = 0;
          let sumY = 0;
          let length = this.checkAreaList.length;
          this.checkAreaList.forEach(function (areaPoint) {
            sumX += areaPoint[0];
            sumY += areaPoint[1];
          });
          if (sumX != 0 & sumY != 0) {
            addMarkInfo.push({  // 区域取中心点位计算
              id: this.areaDetailsInfo.id + '_areaName',
              longitude: Number(),
              latitude: Number(),
              coord: [Number(sumX/length), Number(sumY/length)],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/floor/" + this.areaDetailsInfo.name + ".png",
              sleSrc: "/images/theme/newDark/floor/" + this.areaDetailsInfo.name + ".png",
              attr: {
                ...this.areaDetailsInfo,
              },
            });
          }
          //区域名称打点
          this.$refs.refAppMap.addMarket(
            addMarkInfo,
            this.areaDetailsInfo.id + '_areaName' || this.addPolygonID + '_areaName',
            ''
          );
        }
      }
    },
    // 绘制结束回调
    drawCallback(data) {
      this.checkAreaListCopy = JSON.parse(JSON.stringify(data));
      this.$refs.refAppMap.clearLayer(this.areaDetailsInfo.id || this.addPolygonID);
      this.$refs.refAppMap.addPolygon(
        this.areaDetailsInfo.id || this.addPolygonID,
        this.areaDetailsInfo.color || "#846505",
        [data],
        this.areaDetailsInfo.name
      );
    },
    mapConfirmOpt() {
      this.checkAreaList = JSON.parse(JSON.stringify(this.checkAreaListCopy));
      this.areaDetailsInfo.drawName = "【区域已配置--待保存】";
      this.handleClosePanel();
    },
    // 点击地图框中的取消操作
    handleClosePanel() {
      if (this.showMap) {
        this.$refs.refAppMap.removeDrawFeature(); //关闭绘制并清除
        this.$refs.refAppMap.clearOverlays();
      }
      this.showMap = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.iconBtn {
  position: absolute;
  right: 50px;
  top: 17px;
  cursor: pointer;
}

.tipLabel {
  text-align: right;
  // color: red;
  // margin-top: 10px;
  font-size: 12px;
}

.colorArea {
  // padding: 16px;
  display: flex;
  justify-content: space-between;

  .new,
  .old {
    display: flex;
    margin: 0 15px 10px 0;

    span {
      margin-right: 15px;
    }

    div {
      width: 40px;
      height: 15px;
    }

    .area {
      background: #846505;
    }
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.el-color-picker--mini .el-color-picker__trigger {
  width: 88px !important;
  height: 36px;
  margin-right: 15px;
}

.el-color-picker--mini .el-color-picker__mask {
  width: 88px !important;
  height: 36px;
  margin-right: 15px;
}

.area-manage {
  // margin: 0 16px;
  // width: calc(100% - 32px);
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  flex: 1;

  #mini-map {
    width: 100%;
    height: calc(100% - 30px);
  }

  .el-select {
    width: 100%;
  }

  .area-search {
    display: flex;
    margin: 10px 10px 20px;
    height: 28px;

    .el-input {
      // margin-right: 10px;
      // width: 200px;
      width: 100%;
    }
  }

  // 更改树组件默认样式
  .area-tree-left {
    margin: 0px 8px 0px 0px;
    max-height: 100%;
    overflow: hidden;
    width: 380px;
    border-radius: 5px 5px 0px 0px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .area-title {
      margin: 10px 0 16px 10px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 14px;
      // color: #e8eaee;
    }

    .scroll-bar {
      height: 100%;
      height: calc(100% - 100px);

      .el-scrollbar__wrap {
        .el-scrollbar__view {
          display: inline-block;
          min-width: 100%;
        }
      }
    }

    .tree-label {
      display: inline-block;
      width: 220px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .area-operator {
      display: inline-block;
      margin: 0 20px;

      .el-button {
        // color: #fff !important;
      }
    }

    .tree-content {
      width: fit-content;
      min-width: 100%;

      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .tree-header {
      position: relative;
      background: #3f629c;
      color: #fff;
      font-weight: bold;
      font-size: 13px;

      .area-name {
        padding-left: 10px;
      }
    }

    .custom-info {
      position: absolute;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .area-name {
      width: 80%;
    }

    .operate-btns {
      width: 20%;
      text-align: center;
      right: 10px;
    }
  }

  .area-tree-right {
    flex: 5;
    border-radius: 5px 5px 0px 0px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .btns {
      text-align: center;
    }

    .details {
      margin: 44px 10% 44px 54px;
      position: relative;

      .owner-list {
        position: relative;

        .choose-person {
          position: absolute;
          right: 30px;
        }
      }

      .map-choose {
        position: absolute;
        right: 36px;
        top: 235px;
        font-size: 12px;
      }
    }

    .el-form-item--mini.el-form-item {
      margin-bottom: 30px;
    }
  }

  .choose-container {
    .el-dialog__body {
      .ioc-table {
        position: relative;
        height: 500px;
      }
    }
  }
}
</style>
